<script setup>
import { onMounted } from "vue";
import { RouterView } from "vue-router";
import AppNavbar from "@/components/layout/AppNavbar.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import { upsertJsonLd } from "@/composables/useJsonLd";
import { buildOrganization, buildWebSite } from "@/seo/structuredData";

// Datos estructurados que aplican a todo el sitio (no cambian por ruta),
// por eso se inyectan una sola vez aquí en lugar de por vista.
onMounted(() => {
  upsertJsonLd("ld-organization", buildOrganization());
  upsertJsonLd("ld-website", buildWebSite());
});
</script>
<template>
  <v-app class="background">
    <AppNavbar />

    <v-main>
      <RouterView />
    </v-main>

    <AppFooter />
  </v-app>
</template>
